<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I would like to thank my sister, Stacy, for all her help and work with me on this book; my dad, Connie, brother, Cary, and my sisters, Lisa and Kristen, for all their time as well. My mom for everything. And Angela, who has been a tremendous source of encouragement.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e24ca130